import React, { useCallback, useEffect, useState } from "react";
import {
  APP_VIEW,
  CODE_COUNTRY_FULL_NAME,
  CODE_COUNTRY_USER_PRF,
  GET_ROLE_MANAGEMENT_DATA,
  UPDATE_COUNTRIES_DETIALS,
} from "../../constants/constant";
import {
  getDataWAuth,
  postDataWAuth  
} from "../../utils/api-service";
import { checkErrorMsg } from "../../utils/utils";
import ToastMessageFunction from "../../common/toast-message-function";
import { useTranslation } from "../../common/translation-context";
import DMGrid from "../../common/data-grid/dmGrid";

const RoleManagement = () => {
  const { translate: t } = useTranslation();
  const [roleManagementData, setRoleManagementData] = useState([]); 
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const toastManager = ToastMessageFunction();
  const showToast = useCallback(
    (message, severity) => {
      toastManager.getToast(message, severity);
    },
    [toastManager]
  );

  const loadRoleManagementData = async () => {
    setIsLoaderVisible(true);
    try {
      const response = await getDataWAuth(GET_ROLE_MANAGEMENT_DATA);
      if (response.status === 200) {
        const data = await response.data.data;    
        const dataWithId = data.map((item) => ({
          ...item,
          id: item.id,        
          countries: item.countries.map((code) => CODE_COUNTRY_FULL_NAME[code] || code), // Map country codes to full names
        }));
        setRoleManagementData(dataWithId);
        setIsLoaderVisible(false);
      }
    } catch (error) {
      setIsLoaderVisible(false);
      if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
      else {
        showToast(t("failedToLoad"), "error");
      }
      console.log(error);
    }
  };

  const editRoleManagement = async (values) => {
    setIsLoaderVisible(true); 
    const updatedRoleManagementData = roleManagementData.filter((item) => item.id === values.id);
    updatedRoleManagementData[0].countries = values.countries.map((code) => CODE_COUNTRY_USER_PRF[code] || code);
    try {
      const response = await postDataWAuth(UPDATE_COUNTRIES_DETIALS, updatedRoleManagementData[0]);
      if (response.status === 200) {
        setIsLoaderVisible(false);
        showToast(t("updateRoleManagement"));
      }
    } catch (error) {
      setIsLoaderVisible(false);
      if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
      else showToast(t("failUpdateRole"));
      console.log(error);
    }
    loadRoleManagementData();
  };

  useEffect(() => {
    loadRoleManagementData();
  }, []);

  return (
    <>      
      {toastManager.toast}

      <DMGrid
        id="table"
        view={APP_VIEW.DM}
        enableEditing={true}
        editDisplayMode="row"
        dmView="roleManagement"
        isLoaderVisible={isLoaderVisible}
        row={roleManagementData}
        header="roleManagement"
        count={roleManagementData?.length}
        edit={editRoleManagement}
        isEdit={false}
      />
    </>
  );
};

export default RoleManagement;
